const BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || ''

const DEV_API_PORT_1 = process.env.NEXT_PUBLIC_DEV_API_ENDPOINT_PORT_1 || BASE_URL
const DEV_API_PORT_2 = process.env.NEXT_PUBLIC_DEV_API_ENDPOINT_PORT_2 || BASE_URL
const DEV_API_PORT_5 = process.env.NEXT_PUBLIC_DEV_API_ENDPOINT_PORT_5 || BASE_URL.replace('http', 'ws')
const DEV_API_PORT_6 = process.env.NEXT_PUBLIC_DEV_API_ENDPOINT_PORT_6 || BASE_URL
const DEV_API_PORT_7 = process.env.NEXT_PUBLIC_DEV_API_ENDPOINT_PORT_7 || BASE_URL

const V1_API = '/v1/api'

export const loginUrl = `${DEV_API_PORT_1}${V1_API}/c/auth/login`
export const forgotPasswordUrl = `${DEV_API_PORT_1}${V1_API}/c/auth/forgotpassword`
export const resetPasswordUrl = `${DEV_API_PORT_1}${V1_API}/c/auth/resetpassword`
export const getUserUrl = `${DEV_API_PORT_1}${V1_API}/c/auth/user`
export const acceptTermsUrl = `${DEV_API_PORT_1}${V1_API}/c/auth/terms/accept`
export const listUsersUrl = `${DEV_API_PORT_1}${V1_API}/c/users`
export const tagListUrl = `${DEV_API_PORT_1}${V1_API}/c/auth/tags`
export const GetSettings = `${DEV_API_PORT_1}${V1_API}/c/settings`
export const UpdateSettings = `${DEV_API_PORT_1}${V1_API}/c/settings`
export const SendEmail = `${DEV_API_PORT_1}${V1_API}/c/settings/test-smtp`
export const TestWebhookConnection = `${DEV_API_PORT_1}${V1_API}/c/settings/test-webhook`
export const GetUnsubscribeTemplateNames = `${DEV_API_PORT_1}${V1_API}/c/unsubscribe/preferences-template-names`
export const GetPreviewTemplate = `${DEV_API_PORT_1}${V1_API}/c/system-template/preview-template`
export const GetTemplateNames = `${DEV_API_PORT_1}${V1_API}/c/system-template/get-templates?system_template_category`

export const ExecuteCustomReports = `${DEV_API_PORT_1}${V1_API}/c/custom-reports/execute-query`
export const SaveCustomReport = `${DEV_API_PORT_1}${V1_API}/c/custom-reports`
export const GetAllDataCustomReport = `${DEV_API_PORT_1}${V1_API}/c/custom-reports`
export const CxpCustomReportById = `${DEV_API_PORT_1}${V1_API}/c/custom-reports/:reportId`
export const DownloadCxpCustomReports = `${DEV_API_PORT_1}${V1_API}/c/custom-reports/downloadCsv/:reportId`
export const DownloadCxpCustomReportsPdf = `${DEV_API_PORT_1}${V1_API}/c/custom-reports/downloadPdf/:reportId`
export const ScheduleCustomReport = `${DEV_API_PORT_1}${V1_API}/c/custom-reports/:reportId/schedule`

export const SuppressionListBase = `${DEV_API_PORT_1}${V1_API}/c/suppression-lists`
export const SuppressionListSearch = `${DEV_API_PORT_1}${V1_API}/c/suppression-lists/search`
export const SuppressionListBulkDelete = `${DEV_API_PORT_1}${V1_API}/c/suppression-lists/bulk`
export const SuppressionListUsage = `${DEV_API_PORT_1}${V1_API}/c/suppression-lists/usage`
export const SuppressionListBulkStatus = `${DEV_API_PORT_1}${V1_API}/c/suppression-lists/bulk-status`
export const SuppressionListById = `${DEV_API_PORT_1}${V1_API}/c/suppression-lists/:listId`
export const SuppressionListMembers = `${DEV_API_PORT_1}${V1_API}/c/suppression-lists/:listId/members`
export const SuppressionListMemberById = `${DEV_API_PORT_1}${V1_API}/c/suppression-lists/:listId/members/:memberId`
export const SuppressionListImport = `${DEV_API_PORT_1}${V1_API}/c/suppression-lists/import`
export const SuppressionListImportCommit = `${DEV_API_PORT_1}${V1_API}/c/suppression-lists/import/:draftId/commit`
export const SuppressionListImportStatus = `${DEV_API_PORT_1}${V1_API}/c/suppression-lists/import/:draftId/status`
export const SuppressionListImportFail = `${DEV_API_PORT_1}${V1_API}/c/suppression-lists/import/:draftId/fail`
export const SuppressionListFilters = `${DEV_API_PORT_1}${V1_API}/c/filters/suppression-lists`

export const TestSeedListBase = `${DEV_API_PORT_1}${V1_API}/c/test-seed-lists`
export const TestSeedListBulkDelete = `${DEV_API_PORT_1}${V1_API}/c/test-seed-lists/bulk`
export const TestSeedListBulkStatus = `${DEV_API_PORT_1}${V1_API}/c/test-seed-lists/bulk-status`
export const TestSeedListById = `${DEV_API_PORT_1}${V1_API}/c/test-seed-lists/:listId`
export const TestSeedListMembers = `${DEV_API_PORT_1}${V1_API}/c/test-seed-lists/:listId/members`
export const TestSeedListMemberById = `${DEV_API_PORT_1}${V1_API}/c/test-seed-lists/:listId/members/:memberId`

export const segmentsListUrl = `${DEV_API_PORT_2}${V1_API}/cdp/segments`

export const filterUrl = `${DEV_API_PORT_1}${V1_API}/c/filters`

export const beeFreeApi = `${DEV_API_PORT_1}${V1_API}/c/campaigns/editors/beefree`
export const campaignUrl = `${DEV_API_PORT_1}${V1_API}/c/campaigns`
export const campaignChannelIgnoredValidationsUrl = (campaignId, channelId) =>
  `${campaignUrl}/${campaignId}/channels/${channelId}/ignored-validations`
export const selectedSegmentCampaignUrl = `${DEV_API_PORT_1}${V1_API}/c/campaigns/segments`
export const CampaignDraftTestSend = `${DEV_API_PORT_1}${V1_API}/c/campaigns/draft-test-send`
export const CampaignTestSendLimits = `${DEV_API_PORT_1}${V1_API}/c/campaigns/test-send-limits`
export const CampaignRecipientCount = `${DEV_API_PORT_1}${V1_API}/c/campaigns/recipient-count`
export const txCampaignUrl = `${DEV_API_PORT_1}${V1_API}/c/campaigns/transactional`
export const txCampaignUrlChannel = `${DEV_API_PORT_1}${V1_API}/c/transactional-campaigns`
export const generateSubjectUrl = `${DEV_API_PORT_1}${V1_API}/c/ai`
export const generateImageAIUrl = `${DEV_API_PORT_1}${V1_API}/c/ai/image-generation`
export const generateReportQueryUrl = `${DEV_API_PORT_1}${V1_API}/c/ai/custom-report-query`
export const generateSegmentQueryUrl = `${DEV_API_PORT_1}${V1_API}/c/ai/generate-segment-query`

export const templateUrl = `${DEV_API_PORT_1}${V1_API}/c/templates`
export const templateChannelIgnoredValidationsUrl = (templateId, channelId) =>
  `${templateUrl}/${templateId}/channels/${channelId}/ignored-validations`
export const generateWorkflowUrl = `${DEV_API_PORT_1}${V1_API}/c/ai/generate-automation-workflow`
export const getAutoCompleteTextUrl = `${DEV_API_PORT_1}${V1_API}/c/ai/autocomplete/text`
export const runpodHealthUrl = `${DEV_API_PORT_1}${V1_API}/c/ai/runpod/health`
export const aiHealthUrl = `${DEV_API_PORT_1}${V1_API}/c/ai/health`

export const journeyUrl = `${DEV_API_PORT_7}${V1_API}/ma/journeys`
export const getNodeListUrl = `${DEV_API_PORT_7}${V1_API}/ma/get-node-metadata`

export const getTags = `${DEV_API_PORT_1}${V1_API}/c/tag-search`

export const getDefaultEmailUrl = `${DEV_API_PORT_1}${V1_API}/c/settings`
export const getClientChannels = `${DEV_API_PORT_1}${V1_API}/c/settings/channels`

export const sendTestWhatsappUrl = `${DEV_API_PORT_1}${V1_API}/c/testMessage/whatsapp/sendTestMessage`
export const sendTestSmsUrl = `${DEV_API_PORT_1}${V1_API}/c/testMessage/sms/sendTestMessage`
export const sendTestEmailUrl = `${DEV_API_PORT_1}${V1_API}/c/campaigns/testEmailMessage`

export const channelSettings = `${DEV_API_PORT_1}${V1_API}/c/settings/channel`

//export const audiencesUrl = `${DEV_API_PORT_2}${V1_API}/a/audiences`
//export const audienceImportUrl = `${DEV_API_PORT_2}${V1_API}/a/audience/import`

export const audiencesUrl = `${DEV_API_PORT_2}${V1_API}/cdp/audiences`
export const audienceImportUrl = `${DEV_API_PORT_2}${V1_API}/cdp/imports`

export const notificationSubscribeUrl = `${DEV_API_PORT_1}${V1_API}/c/notification/subscribe`
export const notificationSocketUrl = `${DEV_API_PORT_5}${V1_API}/c/notification/listen`
export const notificationMessageUrl = `${DEV_API_PORT_1}${V1_API}/c/notification/content`
export const notificationBaseUrl = `${DEV_API_PORT_1}${V1_API}/c/notification`
export const markAllNotificationsReadUrl = `${DEV_API_PORT_1}${V1_API}/c/notification/read-all`

export const getClientListUrl = `${DEV_API_PORT_1}${V1_API}/c/auth/clientdata`

export const getLoginClientListUrl = `${DEV_API_PORT_1}${V1_API}/c/auth/login/password`
export const clientLogin = `${DEV_API_PORT_1}${V1_API}/c/auth/login/client-selection`

export const campaignCategoryUrl = `${DEV_API_PORT_1}${V1_API}/c/campaign-category`
export const putCampaignSubjectsUrl = `${DEV_API_PORT_1}${V1_API}/c/ai/campaigns`

export const fetchDashboardDetails = `${DEV_API_PORT_1}${V1_API}/c/dashboard`
export const fetchDashboardAudiencesUrl = `${DEV_API_PORT_1}${V1_API}/c/dashboard/audiences`
export const fetchDashboardSegmentsUrl = `${DEV_API_PORT_1}${V1_API}/c/dashboard/segments`
export const fetchDashboardChannelVolumesUrl = `${DEV_API_PORT_1}${V1_API}/c/dashboard/events/channel-volumes`
export const fetchDashboardOpeningRateUrl = `${DEV_API_PORT_1}${V1_API}/c/dashboard/events/opening-rate`
export const fetchDashboardCampaignsUrl = `${DEV_API_PORT_1}${V1_API}/c/dashboard/campaigns`
export const fetchDashboardClientEvent = `${DEV_API_PORT_1}${V1_API}/c/dashboard/client-event`

export const sendMailToMailpit = `${DEV_API_PORT_1}${V1_API}/c/mailpit/send`
export const replaceMergeTags = `${DEV_API_PORT_1}${V1_API}/c/mailpit/merge-tags/replace`

export const GetClientIDsByUserID = `${DEV_API_PORT_1}${V1_API}/c/client`
export const updateUserclient = `${DEV_API_PORT_1}${V1_API}/c/client/:id/update-user`
export const searchUsers = `${DEV_API_PORT_1}${V1_API}/c/users/search/`

export const getGlobalSearchResults = `${DEV_API_PORT_1}${V1_API}/c/global-search`

export const saveApiTokenList = `${DEV_API_PORT_1}${V1_API}/c/auth/api-token`
export const getApiTokenList = `${DEV_API_PORT_1}${V1_API}/c/auth/api-token/`

export const getTemplatesFilter = `${DEV_API_PORT_1}${V1_API}/c/filters/templates`

export const getUploadMediaUrl = `${DEV_API_PORT_1}${V1_API}/c/media`
export const uploadImageUrl = `${DEV_API_PORT_1}${V1_API}/c/media/images`

export const mailpitURL = `${DEV_API_PORT_6}`

export const externalIdUrl = `${DEV_API_PORT_1}${V1_API}/c/externaltemplates`

export const generateEmailContentUrl = `${DEV_API_PORT_1}${V1_API}/c/ai/generate-email-content`
export const campaignsMergeTagsUrl = `${DEV_API_PORT_1}${V1_API}/c/campaigns/merge-tags`
export const campaignQuickSearchUrl = `${DEV_API_PORT_1}${V1_API}/c/campaigns/quick-search`
export const analyticsQueryUrl = `${DEV_API_PORT_1}${V1_API}/c/analytics/query`

export const mediaLibraryUrl = `${DEV_API_PORT_1}${V1_API}/c/images`
export const mediaLibraryUploadUrl = `${DEV_API_PORT_1}${V1_API}/c/images/upload`
export const mediaLibraryBulkDeleteUrl = `${DEV_API_PORT_1}${V1_API}/c/images/bulk-delete`
export const mediaLibraryFiltersUrl = `${DEV_API_PORT_1}${V1_API}/c/images/filters`
export const mediaAssetsWithVariantsUrl = `${DEV_API_PORT_1}${V1_API}/c/media/assets/with-variants`

export const mediaAssetGroupsUrl = `${DEV_API_PORT_1}${V1_API}/c/media/asset-groups`

export const audienceSampleFileUrl = 'https://static.cxpify.com/customer-sync_Customers_20260609_100000%20(1).csv'
